import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AuthGuard } from './shared/guards/auth.guard';


const routes: Routes = [
  { path: '', component: LandingComponent, data: { title: 'Home' }},
  { path: 'procurement', canActivate: [AuthGuard], loadChildren: () => import('../app/procurement/procurement.module').then(p => p.ProcurementModule) },
  { path: 'session', loadChildren: () => import('../app/session/session.module').then(p => p.SessionModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
